import { ParseOptions } from 'query-string'
import { SwiperOptions } from 'swiper'
import { IPostalCodeRange, Regions } from 'types/contact'

export function addStar(value: string): string {
  return `${value} *`
}

export const ALLOWED_EXTENSIONS = ['.pdf', '.png', '.jpg', '.jpeg', '.xls', '.xlsx', '.dwg', '.dxf']

export const PHONE_WIDTH = 600
export const TABLET_PORTRAIT_WIDTH = 900
export const ANTIFORGERY_INPUT_NAME = '__RequestVerificationToken'
export const DEFAULT_MAX_UPLOAD_SIZE_MB = 5
export const BASE_URL = `${window.LOCALE ? '/' + window.LOCALE : ''}/storefrontapi`
export const CURRENT_STORE = window.CURRENT_STORE
export const IS_NL_STORE = window.CURRENT_STORE === 'HakronNL'
export const IS_BE_STORE = window.CURRENT_STORE === 'HakronBE'
export const IS_CERTACON_STORE = window.CURRENT_STORE === 'Certacon'
export const IS_SB_STORE = window.CURRENT_STORE === 'StoterBeton'
export const IS_HOUTBOUW_STORE = window.CURRENT_STORE === 'Houtbouw'

export const CHECK_MAIL = 'Email zonder versturen'
export const SEND_MAIL = 'Email'

export const DEFAULT_SWIPER_OPTIONS: SwiperOptions = {
  grabCursor: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  speed: 750,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
}

export const DEFAULT_SWIPER_WITH_AUTOPLAY_OPTIONS: SwiperOptions = {
  ...DEFAULT_SWIPER_OPTIONS,
  autoplay: true
}

export const QUERY_STRING_OPTIONS: ParseOptions = {
  arrayFormat: 'comma'
}
export const SEARCH_QUERY_STRING = 'q'

// 6600 to 6999 is a not covered region
// 1
const POSTAL_CODE_RANGES_BE_RAYON1 = [
  { from: 7500, to: 7999 },
  { from: 8000, to: 8999 }
]

// 2
const POSTAL_CODE_RANGES_BE_RAYON2 = [
  { from: 1540, to: 1559 },
  { from: 1570, to: 1599 },
  { from: 1670, to: 1699 },
  { from: 1750, to: 1779 },

  { from: 9000, to: 9099 },
  { from: 9160, to: 9169 },
  { from: 9185, to: 9189 },
  { from: 9200, to: 9219 },
  { from: 9230, to: 9249 },
  { from: 9255, to: 9999 }
]

// 3
const POSTAL_CODE_RANGES_BE_RAYON3 = [
  { from: 1840, to: 1849 },
  { from: 1880, to: 1909 },
  { from: 1980, to: 1999 },

  { from: 2000, to: 2199 },
  { from: 2220, to: 2229 },
  { from: 2500, to: 2519 },
  { from: 2530, to: 2559 },
  { from: 2530, to: 2559 },
  { from: 2570, to: 2969 },
  { from: 2990, to: 2999 },

  { from: 9100, to: 9159 },
  { from: 9170, to: 9184 },
  { from: 9190, to: 9199 },
  { from: 9220, to: 9229 },
  { from: 9250, to: 9254 }
]

// 4
const POSTAL_CODE_RANGES_BE_RAYON4 = [
  { from: 2000, to: 2219 },
  { from: 2230, to: 2499 },
  { from: 2520, to: 2529 },
  { from: 2560, to: 2569 },
  { from: 2970, to: 2989 },

  { from: 3200, to: 3999 }
]

// 5
const POSTAL_CODE_RANGES_BE_RAYON5 = [
  { from: 1000, to: 1299 },

  { from: 1500, to: 1539 },
  { from: 1560, to: 1569 },
  { from: 1600, to: 1669 },
  { from: 1700, to: 1749 },
  { from: 1780, to: 1839 },
  { from: 1850, to: 1879 },
  { from: 1910, to: 1979 },

  { from: 3000, to: 3199 }
]

// 6
const POSTAL_CODE_RANGES_BE_RAYON6 = [
  { from: 1300, to: 1499 },
  { from: 4000, to: 4999 },
  { from: 5000, to: 5999 },
  { from: 6000, to: 6599 },
  { from: 7000, to: 7499 }
]

const POSTAL_CODE_RANGES_RAYON1_NL = [
  { from: 3840, to: 3849 },
  { from: 3888, to: 3888 },
  { from: 6960, to: 6971 },
  { from: 6975, to: 6975 },
  { from: 7140, to: 7218 },
  { from: 7223, to: 7223 },
  { from: 7226, to: 7226 },
  { from: 7230, to: 7251 },
  { from: 7260, to: 7261 },
  { from: 7270, to: 7275 },
  { from: 7300, to: 7348 },
  { from: 7360, to: 8199 },
  { from: 8250, to: 9999 }
]
const POSTAL_CODE_RANGES_RAYON2_NL =[
  { from: 1230, to: 1231 },
  { from: 2155, to: 2180 },
  { from: 2200, to: 2204 },
  { from: 2215, to: 2430 },
  { from: 2445, to: 2460 },
  { from: 2465, to: 2481 },
  { from: 2491, to: 2819 },
  { from: 3140, to: 3160 },
  { from: 3422, to: 3425 },
  { from: 3440, to: 3632 },
  { from: 3651, to: 3651 },
  { from: 3653, to: 3836 },
  { from: 3850, to: 3886 },
  { from: 3900, to: 3912 },
  { from: 3925, to: 3941 },
  { from: 3947, to: 3985 },
  { from: 4020, to: 4021 },
  { from: 4024, to: 4043 },
  { from: 4050, to: 4054 },
  { from: 4122, to: 4123 },
  { from: 4161, to: 4173 },
  { from: 4209, to: 4248 },
  { from: 6666, to: 6674 },
  { from: 6700, to: 6745 },
  { from: 6866, to: 6877 },
  { from: 7350, to: 7352 }
]
const POSTAL_CODE_RANGES_RAYON3_NL = [
  { from: 2820, to: 2950 },
  { from: 2951, to: 2979 },
  { from: 2980, to: 3139 },
  { from: 3161, to: 3364 },
  { from: 3365, to: 3421 },
  { from: 3430, to: 3439 },
  { from: 3945, to: 3945 },
  { from: 3989, to: 4017 },
  { from: 4023, to: 4023 },
  { from: 4060, to: 4121 },
  { from: 4124, to: 4157 },
  { from: 4158, to: 4160 },
  { from: 4174, to: 4208 },
  { from: 4249, to: 4264 },
  { from: 4271, to: 4286 },
  { from: 4287, to: 4854 },
  { from: 4869, to: 5049 },
  { from: 5056, to: 5057 },
  { from: 5071, to: 5074 },
  { from: 5101, to: 5109 },
  { from: 5120, to: 5122 },
  { from: 5141, to: 5176 },
  { from: 5250, to: 5254 },
  { from: 5266, to: 5268 },
  { from: 5300, to: 5324 }
]
const POSTAL_CODE_RANGES_RAYON4_NL = [
  { from: 3920, to: 3922 },
  { from: 4268, to: 4268 },
  { from: 4861, to: 4861 },
  { from: 5051, to: 5053 },
  { from: 5061, to: 5066 },
  { from: 5076, to: 5095 },
  { from: 5111, to: 5111 },
  { from: 5125, to: 5140 },
  { from: 5200, to: 5249 },
  { from: 5255, to: 5264 },
  { from: 5270, to: 5298 },
  { from: 5325, to: 6665 },
  { from: 6675, to: 6691 },
  { from: 6800, to: 6865 },
  { from: 6880, to: 6924 },
  { from: 6930, to: 6957 },
  { from: 6974, to: 6974 },
  { from: 6980, to: 7137 },
  { from: 7220, to: 7221 },
  { from: 7224, to: 7225 },
  { from: 7227, to: 7227 },
  { from: 7255, to: 7256 },
  { from: 7263, to: 7263 }
]
const POSTAL_CODE_RANGES_RAYON5_NL = [
  { from: 1000, to: 1223 },
  { from: 1232, to: 2154 },
  { from: 2181, to: 2199 },
  { from: 2205, to: 2214 },
  { from: 2431, to: 2444 },
  { from: 2461, to: 2464 },
  { from: 2482, to: 2490 },
  { from: 3633, to: 3650 },
  { from: 3652, to: 3652 },
  { from: 3890, to: 3899 },
  { from: 8200, to: 8245 }
]

export const REGIONS_WITH_POSTAL_CODES_BE: { [key in Regions]?: IPostalCodeRange[] } = {
  [Regions.BERayon1]: POSTAL_CODE_RANGES_BE_RAYON1,
  [Regions.BERayon3]: POSTAL_CODE_RANGES_BE_RAYON3,
  [Regions.BERayon2]: POSTAL_CODE_RANGES_BE_RAYON2,
  [Regions.BERayon4]: POSTAL_CODE_RANGES_BE_RAYON4,
  [Regions.BERayon5]: POSTAL_CODE_RANGES_BE_RAYON5,
  [Regions.BERayon6]: POSTAL_CODE_RANGES_BE_RAYON6
}

export const REGIONS_WITH_POSTAL_CODES_NL: { [key in Regions]?: IPostalCodeRange[] } = {
  [Regions.Rayon1]: POSTAL_CODE_RANGES_RAYON1_NL,
  [Regions.Rayon2]: POSTAL_CODE_RANGES_RAYON2_NL,
  [Regions.Rayon3]: POSTAL_CODE_RANGES_RAYON3_NL,
  [Regions.Rayon4]: POSTAL_CODE_RANGES_RAYON4_NL,
  [Regions.Rayon5]: POSTAL_CODE_RANGES_RAYON5_NL
}

//product detail
export const PIB = 'Product informatie blad'
export const PIB_BE = 'Technische fiche'
export const PIB_FR = 'Fiche technique'

export const PROP_ICONS_LIST = 'prop--210'
export const PROP_VIDEO_ID = 'prop--490'

export const TERMS_PARAM = 'terms'
export const PAGE_PARAM = 'page'

export const TIMEOUT_AMOUNT_ROUND_OFF_MESSAGE = 4000

export const IMAGE_GROUP_NAME_MAIN = 'Main Image'
export const IMAGE_GROUP_NAME_DETAILS = 'Detail afbeelding'
export const IMAGE_GROUP_NAME_ADDITIONAL = 'Extra productafbeelding'
export const IMAGE_GROUP_APPLICATION = 'Toepassingsafbeelding'
export const IMAGE_GROUP_NAME_DIMENSIONAL_DRAWING = 'Maattekening'
export const IMAGE_GROUP_NAME_MOUNTING = 'Montage afbeelding'
export const IMAGE_GROUP_TO_SHOW = [
  IMAGE_GROUP_NAME_MAIN,
  IMAGE_GROUP_NAME_DETAILS,
  IMAGE_GROUP_NAME_ADDITIONAL,
  IMAGE_GROUP_APPLICATION,
  IMAGE_GROUP_NAME_DIMENSIONAL_DRAWING,
  IMAGE_GROUP_NAME_MOUNTING
]

let propUnitId = 'prop--401'
let propMinAmoutID = 'prop--407'
let propAmoutID = 'prop--378'
let propMultipleRequiredId = 'prop--379'

if (IS_BE_STORE) { //500
  propUnitId = 'prop--405'
  propMinAmoutID = 'prop--411'
  propAmoutID = 'prop--390'
  propMultipleRequiredId = 'prop--391'
} else if (IS_CERTACON_STORE) { //200
  propUnitId = 'prop--402'
  propMinAmoutID = 'prop--408'
  propAmoutID = 'prop--381'
  propMultipleRequiredId = 'prop--382'
} else if (IS_SB_STORE) { //400
  propUnitId = 'prop--404'
  propMinAmoutID = 'prop--410'
  propAmoutID = 'prop--387'
  propMultipleRequiredId = 'prop--388'
}

export const PROP_UNIT_ID = propUnitId
export const PROP_MIN_AMOUNT_ID = propMinAmoutID
export const PROP_AMOUNT_ID = propAmoutID
export const PROP_MULTIPLE_REQUIRED_ID = propMultipleRequiredId

export const PROP_SHOW_VARIANT_TABLE = 'ShowVariantTable'
export const PROP_BE_VARIANT_TABLE_TITLE = 'prop--357'

export const ATTR_UNITOFMEASURE = `UNITOFMEASURE-${window.LOCALE}`
export const ATTR_PROPERTYGROUP = `PROPERTYGROUP-${window.LOCALE}`
export const ATTR_PROPERTYGROUP_ID = 'PROPERTYGROUP-Id'

export const PROP_ASSOCIATIONS_TITLE = 'prop--339'
